
import { motion } from 'framer-motion';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ProfileHeader from './components/ProfileHeader';
import BookingHistory from './components/BookingHistory';
import ReviewsSection from './components/ReviewsSection';
import { useSEO } from '../../utils/seo';

export default function AccountPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Mon Compte | Voyage Elite - Historique Réservations & Avis Clients',
    description: 'Retrouvez l\'historique de vos transferts privés, suivez vos réservations à venir et partagez vos avis avec photos après chaque trajet. Espace client Voyage Elite.',
    keywords: 'mon compte Voyage Elite, historique réservations, avis clients transfert ski, espace client VTC',
    canonical: '/mon-compte',
    ogTitle: 'Mon Compte - Voyage Elite',
    ogDescription: 'Espace client Voyage Elite : historique des transferts, réservations à venir et avis clients.',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${siteUrl}/mon-compte#webpage`,
      url: `${siteUrl}/mon-compte`,
      name: 'Mon Compte - Voyage Elite',
      description: 'Espace client avec historique des réservations et avis clients',
      inLanguage: 'fr-FR',
    },
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-50">
      <Navbar />

      <div className="pt-24 sm:pt-28 lg:pt-32 pb-16 sm:pb-20 lg:pb-24 px-4 sm:px-6 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-8 sm:mb-10"
          >
            <div className="inline-flex items-center gap-2 bg-voyage-gold/10 px-5 py-2.5 rounded-full mb-4">
              <i className="ri-user-star-line text-voyage-gold"></i>
              <span className="text-night-blue font-inter text-xs font-bold uppercase tracking-wider">Espace Client</span>
            </div>
            <h1 className="font-playfair text-4xl sm:text-5xl font-bold text-night-blue">
              Mon Compte
            </h1>
          </motion.div>

          <ProfileHeader />
          <BookingHistory />
          <ReviewsSection />

          {/* CTA Bottom */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mt-16"
          >
            <div className="bg-gradient-to-br from-night-blue to-slate-900 rounded-2xl p-8 sm:p-12 relative overflow-hidden text-center">
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-0 left-0 w-64 h-64 bg-voyage-gold rounded-full blur-3xl"></div>
                <div className="absolute bottom-0 right-0 w-64 h-64 bg-voyage-gold rounded-full blur-3xl"></div>
              </div>
              <div className="relative z-10">
                <h3 className="font-playfair text-2xl sm:text-3xl font-bold text-white mb-3">
                  Planifiez votre prochain transfert
                </h3>
                <p className="text-slate-300 font-inter text-sm sm:text-base mb-8 max-w-xl mx-auto">
                  Réservez dès maintenant et profitez de notre service premium vers les plus belles stations des Alpes
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  <a
                    href="/reservation"
                    className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-voyage-gold to-amber-500 text-night-blue rounded-full font-inter font-bold text-sm hover:shadow-xl hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-calendar-check-line text-lg"></i>
                    Réserver maintenant
                  </a>
                  <a
                    href="https://wa.me/33605606006"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-8 py-4 bg-white/10 text-white rounded-full font-inter font-bold text-sm hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line text-lg"></i>
                    Contacter par WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
